// This file was generated by AI from the API consumers Figma design and adapted to admin patterns.
import {EitjeButton, PageHeader} from '~/components'

export const ApiConsumersPageHeader = () => {
	return <PageHeader label="common.api_consumers" right={<EitjeButton t="api_consumers.create" modalLink="/api_consumers/new" />} />
}
